import React, { useState, useEffect} from 'react';

export default function Add(onAdd) {
    const DEFAULT_VENUE = 'costco';
    const DEFAULT_VENUES = ['costco','meijer'];
    let [name,set_name] = useState('');
    let [venue,set_venue] = useState(DEFAULT_VENUE);

    const options = DEFAULT_VENUES.map(v =>
        <option key={v} value={v}>{v}</option>
    );

    const escFunction =function(event) {
        if (event.key === "Escape") {
            onAdd.onAdd(undefined, undefined);
        }
    }

    function hide(){
        onAdd.onAdd(undefined,undefined);
    }

    useEffect(() => {
        document.addEventListener("keydown", escFunction, false);

        return () => {
            document.removeEventListener("keydown", escFunction, false);
        };
    });

    const handleClick = function () {
        onAdd.onAdd(name,venue);
    }

    function handleNameChange(event) {
        set_name(event.target.value);
    }

    function handleVenueChange(event) {
        set_venue(event.target.value);
    }

    const selectStyle = {
        width: "100%",
        textAlign: "center",
        backgroundColor: "#282c34",
        color: "white",
        fontSize: "inherit",
        padding: "4px",
    }

    const addStyle = (name && name.trim().length > 0 ) ? {} : {disabled: true};

    return (
        <div className="App-body">

            <header className="App-vertical-body">
                <div>
                <h2>Add Sumthin</h2>
                </div>
                <table>
                    <tbody>
                    <tr>
                        <th>Name</th>
                        <td><input style={selectStyle} type="text" name="name" placeholder="sumthin..." onChange={handleNameChange} autoFocus onKeyDown={(e) => { if (e.key === 'Enter' && name && name.trim().length > 0) handleClick(); }}/></td>
                    </tr>
                    <tr>
                        <th>Venue</th>
                        <td><select style={selectStyle} value={venue} onChange={handleVenueChange}>{options}</select></td>
                    </tr>
                    <tr><td colSpan='2'>
                        <button className='yellow_button' onClick={hide}>Cancel</button>
                        <button style={addStyle} className='button-3' onClick={handleClick}>Add</button>
                    </td></tr>
                    </tbody>
                </table>
            </header>
        </div>
    );
}